import React from 'react';
import Label from '../../Label';

export default function Title(props) {
  const { title } = props;
  return <Label>{title}</Label>;
}
